import React from "react";

const Injury = ({ size = 50, color }: any) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 384"
      width={size}
      height={size}
    >
      <path
        fill="none"
        className="cls-1"
        d="M114,489.28H18v-384H402v384H330.75c0-.63.13-1.25.13-1.87,0-41.91.18-83.82-.06-125.72-.23-39.2-27.36-71.4-65.95-78.66a10.63,10.63,0,0,0-6.89,1.4c-17.94,11.17-37.31,15.92-58.31,13.31-6.49-.81-12.88-2.48-19.38-3.77a3,3,0,0,0,0,.89c7.31,27.44,14.68,54.86,21.88,82.32.72,2.75,2.21,2.74,4.32,2.74,19,0,38-.28,57,.1,29.1.58,48.13,31.73,35.35,57.83-7.86,16.06-21.33,23.41-39.07,23.41q-70.11,0-140.22,0h-5.21c0,2.06,0,3.65,0,5.25Q114.18,477.89,114,489.28ZM154,283.36c-1.25.21-2.21.3-3.15.52-36.06,8.45-61.41,40.45-61.65,78.08-.16,24.31,0,48.63,0,72.94,0,1.2.12,2.39.2,3.66h106ZM276,183.39H143.68c.41,12.65-.28,25.12,1.43,37.25,4.25,30.14,30.44,53.61,60.23,55.25,31.79,1.74,59.68-17.89,68.13-48C277.56,213.34,275.31,198.44,276,183.39Zm-66.47,219c-.15.56-.31.82-.26,1,2.95,11.18,5.86,22.38,9,33.51.24.84,1.92,1.82,2.94,1.83,13.48.12,27,.24,40.43,0,10.84-.17,18.79-8.17,18.72-18.3-.06-10.29-8.25-18-19.29-18.06-12.36-.06-24.71,0-37.06,0Zm28.71-289.71c-38.82-18.81-82.23,5.47-90.92,40.43Zm-51.42,47.75h87.94a65.55,65.55,0,0,0-13.49-29.86c-1.6-2.05-2.91-2.34-5.31-1.26-21.84,9.82-43.74,19.51-65.62,29.25C189.41,158.94,188.52,159.5,186.85,160.39Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        d="M114,489.28q.16-11.4.34-22.78c0-1.6,0-3.19,0-5.25h5.21q70.11,0,140.22,0c17.74,0,31.21-7.35,39.07-23.41,12.78-26.1-6.25-57.25-35.35-57.83-19-.38-38-.12-57-.1-2.11,0-3.6,0-4.32-2.74-7.2-27.46-14.57-54.88-21.88-82.32a3,3,0,0,1,0-.89c6.5,1.29,12.89,3,19.38,3.77,21,2.61,40.37-2.14,58.31-13.31a10.63,10.63,0,0,1,6.89-1.4c38.59,7.26,65.72,39.46,65.95,78.66.24,41.9.06,83.81.06,125.72,0,.62-.09,1.24-.13,1.87Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        d="M154,283.36l41.35,155.2h-106c-.08-1.27-.2-2.46-.2-3.66,0-24.31-.14-48.63,0-72.94.24-37.63,25.59-69.63,61.65-78.08C151.74,283.66,152.7,283.57,154,283.36Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        d="M276,183.39c-.72,15.05,1.53,30-2.56,44.52-8.45,30.09-36.34,49.72-68.13,48-29.79-1.64-56-25.11-60.23-55.25-1.71-12.13-1-24.6-1.43-37.25Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        d="M209.56,402.35H224c12.35,0,24.7,0,37.06,0,11,.05,19.23,7.77,19.29,18.06.07,10.13-7.88,18.13-18.72,18.3-13.47.22-26.95.1-40.43,0-1,0-2.7-1-2.94-1.83-3.12-11.13-6-22.33-9-33.51C209.25,403.17,209.41,402.91,209.56,402.35Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        d="M238.27,112.64l-90.92,40.43C156,118.11,199.45,93.83,238.27,112.64Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        d="M186.85,160.39c1.67-.89,2.56-1.45,3.52-1.87,21.88-9.74,43.78-19.43,65.62-29.25,2.4-1.08,3.71-.79,5.31,1.26a65.55,65.55,0,0,1,13.49,29.86Z"
        transform="translate(-18 -105.28)"
      />
    </svg>
  );
};

export default Injury;
